import React from 'react';
import { SegmentedControl } from '@parsina/framework';

import { useTranslation } from '../../i18n/I18nProvider.jsx';
import VisitHeader from './VisitHeader.jsx';
import RecordRail from './rail/RecordRail.jsx';
import WorkPanel from './work/WorkPanel.jsx';
import CopilotPanel from './copilot/CopilotPanel.jsx';
import { MOBILE_SEGMENTS } from './Visit.shared.js';

// The phone workspace: ONE scroll region, addressed by a segmented control —
// «پرونده · یادداشت · تشخیص · نسخه · دستورات · دستیار» (core.md §7.5), with the
// rail as the first segment.
//
// Not a reduction of the three columns but a re-projection of them: at 360px a
// collapsible rail beside a note is two unusable columns, so the same six
// surfaces become six destinations. The segments are in the DESKTOP order, left
// to right, so the two surfaces teach the same shape.
//
// The bottom nav is hidden on this route (`isVisitPath` in constants/routes.js):
// this is a full-height workspace with its own back button, and a student in a
// visit is in a visit.

export default function VisitMobile({ vm }) {
  const { t } = useTranslation();
  const segment = vm.mobileSegment;

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}
      data-testid="visit-mobile"
    >
      <VisitHeader
        encounter={vm.encounter}
        patient={vm.patient}
        saveState={vm.saveState}
        onRetrySave={vm.retrySave}
        onBack={vm.onBack}
        onEnd={vm.onEnd}
        onReopen={vm.onReopen}
        onCancel={vm.onCancel}
        readOnly={vm.readOnly}
        compact
      />

      <div style={{ padding: '8px 10px 0', overflowX: 'auto' }}>
        <SegmentedControl
          options={MOBILE_SEGMENTS.map((id) => ({
            value: id,
            label: t(id === 'record' ? 'visit.rail.title'
              : id === 'assistant' ? 'visit.copilot.title'
                : `visit.tabs.${id}`),
          }))}
          value={segment}
          onChange={vm.setMobileSegment}
          size="sm"
          ariaLabel={t('visit.tabs.aria')}
          data-testid="visit-mobile-segments"
        />
      </div>

      <div
        style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 10, display: 'flex', flexDirection: 'column' }}
        data-testid="visit-mobile-body"
      >
        {segment === 'record' && (
          <RecordRail record={vm.record} onAddVitals={vm.addVitals} readOnly={vm.readOnly} />
        )}
        {segment === 'assistant' && (
          <CopilotPanel vm={vm} tab={vm.copilotTab} onTab={vm.setCopilotTab} />
        )}
        {segment !== 'record' && segment !== 'assistant' && (
          <WorkPanel vm={vm} tab={segment} />
        )}
      </div>
    </div>
  );
}
